import { format, getDate, getYear, getMonth } from "date-fns";

import { FORMAT_DATE, FORMAT_DATETIME, FORMAT_DATETIME_FILE, URL_DOWNLOAD } from "const/CommonConst";

const padLeft = (num, places, value) => String(num).padStart(places, value)

const CommonUtils = {  
    padLeftContent: (text, places, value) => {
    try {
     return String(text).padStart(places,value)
    } catch (error) {
      console.error(error.message);
  
      return '';
    }
  },
    getDate: (date) => {
    try {
      if (date) {
        return new Date(date);
      }
      return new Date();
    } catch (error) {
      console.error(error.message);
  
      return new Date();
    }
  },
      formatDate: (date) => {
      try {
        if (date) {
          return format(new Date(date), FORMAT_DATE);
        }
        return "";
      } catch (error) {
        console.error(error.message);
  
        return "";
      }
    },
    formatDateTime: (date) => {
      try {
          if (date) {
            return format(new Date(date), FORMAT_DATETIME);
          }
        return "";
      } catch (error) {
        console.error(error.message);
  
        return "";
      }
    },
    getDateForServer: (date) => {
      try {
  var day = date.getDate();       // yields date
  var month = date.getMonth() + 1;    // yields month (add one as '.getMonth()' is zero indexed)
  var year = date.getFullYear();  // yields year
 
  
  // After this construct a string with the above results as below
        return padLeft(day, 2, '0') + "/" + padLeft(month, 2, '0') + "/" + padLeft(year, 4, '0') ; 
      } catch (error) {
        console.error(error.message);
  
        return "";
      }
    },
    getDateForFile: () => {
      try {
        return format(new Date(), FORMAT_DATETIME_FILE);
      } catch (error) {
        console.error(error.message);
  
        return "";
      }
    },
    donwloadFile: (url) => {
      try {
        window.open(`${URL_DOWNLOAD}${url}`, "_blank");
      } catch (error) {
        console.error(error.message);
      }
    },
    donwloadXlsxFromBlob: (data, prefixName) => {
      try {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));              
          const link = document.createElement('a');
        
                link.href = downloadUrl;
        
                link.setAttribute('download', `${prefixName} ${format(new Date(), FORMAT_DATETIME_FILE)}.xlsx`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
      } catch (error) {
        console.error(error.message);
      }
    },
    isNumber: (val) => {
      const result = parseFloat(val);
      if (isNaN(result)) {
        return false;
      }
      return true;
    },
    convertToInt: (val) => {
      if (!val)
        return 0;
        
      const result = parseInt(val);
      if (isNaN(result)) {
        return 0;
      }
      return result;
    },
    verifyEmail: (value) => {
      var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailRex.test(value)) {
        return true;
      }
      return false;
    },
    verifyPhone: (value) => {
      var phoneRex = /^(?:\d{2}?\d{3}?\d{5})$/;
      if (phoneRex.test(value)) {
        return true;
      }
      return false;
    },  
    verifyLength: (value, length) => { // function that verifies if a string has a given length or not
      if (value.length >= length) {
        return true;
      }
      return false;
    },  
    compare: (string1, string2) => { // function that verifies if two strings are equal
      if (string1 === string2) {
        return true;
      }
      return false;
    },
    verifyNumber: (value) => { // function that verifies if value contains only numbers
      var numberRex = new RegExp("^[0-9]+$");
      if (numberRex.test(value)) {
        return true;
      }
      return false;
    },  
    verifyUrl: (value) => { // verifies if value is a valid URL
      try {
        new URL(value);
        return true;
      } catch (_) {
        return false;
      }
    },
    getNewUUID: (value) => { // verifies if value is a valid URL
      try {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
      } catch (_) {
        return "";
      }
    },
  };
  
  export default CommonUtils;